// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bulbasaur: PokeData = {
  "id": 1,
  "name": "bulbasaur",
  "height": 7,
  "weight": 69,
  "base_experience": 64,
  "types": [
    PokeType.GRASS,
    PokeType.POISON
  ],
  "api_moves": [
    "vine-whip",
    "tackle",
    "take-down",
    "double-edge",
    "growl",
    "leech-seed",
    "growth",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "sleep-powder",
    "sweet-scent",
    "synthesis",
    "worry-seed",
    "seed-bomb",
    "power-whip"
  ],
  "moves": [
    "vine-whip",
    "tackle",
    "growl",
    "razor-leaf",
    "solar-beam",
    "poison-powder",
    "synthesis",
    "power-whip",
    "poison-jab",
    "poison-gas",
    "acid",
    "bullet-seed",
    "stun-spore"
  ],
  "evolution_chain": {
    "id": 1,
    "item": null,
    "species": [
      {
        "name": "bulbasaur",
        "order": 1,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ivysaur",
        "order": 2,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 1,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "venusaur",
        "order": 3,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 2,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51,
    "speed": 45,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
